export const ROLES_USUARIO = {
  administrador: {
    etiqueta: 'Administrador',
    clase: 'bg-emerald-100 text-emerald-700',
  },
  aprobador: {
    etiqueta: 'Aprobador',
    clase: 'bg-blue-100 text-blue-700',
  },
  usuario: {
    etiqueta: 'Usuario',
    clase: 'bg-slate-100 text-slate-700',
  },
  consulta: {
    etiqueta: 'Solo consulta',
    clase: 'bg-amber-100 text-amber-700',
  },
  pos_venta: {
    etiqueta: 'POS Venta',
    clase: 'bg-indigo-100 text-indigo-700',
  },
}

export function obtenerRolInfo(rol) {
  return (
    ROLES_USUARIO[rol] || {
      etiqueta: rol || 'Sin rol',
      clase: 'bg-slate-100 text-slate-600',
    }
  )
}
